    angular.module('service-request', ['core', 'service-request.status', 'service-request-integration', 'service-request.handover', 'clients.finder'])
        .constant('ServiceRequestConst', {
            eventUpdate: 'service-request.updated'
        })
        .factory('ServiceRequest', function ($resource) {
            return  $resource('/crm/api/service-request/:id', {id: "@id"}, {
                find: {method: 'GET', isArray: true},
                list: {method: 'GET', isArray: true},
                get: {method: 'GET'},
                table: {method: 'GET', isArray: false, url: '/crm/api/service-request/table'},
                tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/service-request/table-statistics'},
                update: {method: 'PUT'},
                statusChange: {method: 'POST', url: '/crm/api/service-request/:id/status-change'},
                pass: {method: 'PUT', url: '/crm/api/service-request/:id/pass'},
                passOptOut: {method: 'PUT', url: '/crm/api/service-request/:id/pass-opt-out'},
                remove: {method: 'DELETE'}
            });
        })
        .service('ServiceRequestService', function ($rootScope, toastr, modals, ServiceRequest, ServiceRequestStatusService, ServiceRequestConst) {
            this.edit = id => ServiceRequest.get({id: id}).$promise.then(item => edit_modal(item));
            this.add = (properties, source) => {
                let entity = {
                    id: null,
                    status: "FILLED",
                    filledInAt: new Date().toISOString().slice(0, 10)
                };
                angular.extend(entity, properties);
                return edit_modal(entity, source);
            };
            this.show = id => {
                ServiceRequest.get({id: id}).$promise.then(item => {
                    modals.open('app/service-request/show-modal.html', 'ServiceRequestShowModalController', item, {size: "lg"}, "$ctrl")
                });
            };
            this.pass = item => {
                return modals.open('app/service-request/pass-modal.html', 'ServiceRequestPassController', item, {size: "sm"}, "$ctrl")
            }
            this.passOptOut = item => {
                return modals.open('app/service-request/pass-opt-out-modal.html', 'ServiceRequestPassOptOutController', item, {size: "sm"}, "$ctrl")
            }
            this.delete = item => modals.confirmDelete("wybrany rekord", () => {
                ServiceRequest.delete({id: item.id}, () => $rootScope.$broadcast(ServiceRequestConst.eventUpdate));
            });
            this.isOpen = item => {
                return item.status && item.status !== 'CLOSED' && item.status !== 'CANCELLED';
            }
            this.statusChange = id => {
                ServiceRequestStatusService.statusChange(id);
            }

            function edit_modal(entity, source) {
                let data = {
                    item: entity,
                    source: source
                };
                return modals.open('app/service-request/edit-modal.html', 'ServiceRequestDialogController', data, {size: "lg"}, "$ctrl");
            }
        })
        .controller('ServiceRequestShowModalController', function ($scope, $uibModalInstance, data, ServiceRequest, ServiceRequestService, ServiceRequestConst, Principal) {
            this.ServiceRequestService = ServiceRequestService;
            this.item = data;
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);

            this.onServiceRequestsLoaded = page => {
                this.serviceRequestsCount = page.fullListSize || 0
            }

            this.close = () => $uibModalInstance.dismiss('Canceled');

            $scope.$on('client.updated', () => ServiceRequest.get({id: data.id}).$promise.then(entity => this.item.client = entity.client));
            $scope.$on(ServiceRequestConst.eventUpdate, () => ServiceRequest.get({id: data.id}).$promise.then(entity => this.item = entity).catch(() => this.close()));
        })
        .controller('ServiceRequestDialogController', function ($scope, $rootScope, $uibModalInstance, data, Numeration, PropertyService, ServiceRequestService, ServiceRequest, ClientFinderService, ClientLead, ServiceRequestConst, PhoneNumberFormatter, Principal) {
            this.ServiceRequestService = ServiceRequestService;

            this.$onInit = ()=> {
                this.item = data.item
                this.source = data.source
                this.canReadLeadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_READ', 'ROLE_CLIENTS_LEAD_READ'])

                if (!this.item.id) {
                    Numeration.nextNumber({clazz: "pl.multisoft.modules.request.ServiceRequest"}).$promise.then(result => {
                        this.item.number = result.number;
                    });
                }
                this.suggestClient();
            }

            this.suggestClient = () => {
                if (this.source && this.canReadLeadClients){
                    ClientLead.suggest({email: this.source.email, phone: this.source.phone}).$promise.then(clients => {
                        this.source.suggestedClients = clients;
                        if(clients.length === 1){
                            this.onClientSelected(clients[0]);
                        }
                    })
                }
            }

            this.selectProperty = () => {
                PropertyService.selectPropertyBasic(this.item.subjectOfClaim?.project?.id).then((property) => {
                    this.item.subjectOfClaim.property = property;
                });
            }

            this.cancel = () => $uibModalInstance.dismiss('Canceled');

            this.save = () => {
                let promise
                if (this.item.id !== null) {
                    promise = ServiceRequest.update(this.item).$promise
                } else {
                    promise = ServiceRequest.save(this.item).$promise
                }
                return promise.then(result => {
                    $rootScope.$broadcast(ServiceRequestConst.eventUpdate);
                    $uibModalInstance.close(result);
                })
            };

            this.onClientSelected = (value) => {
                if(value){
                    this.item.client = value;
                }
                else {
                    delete this.item.client;
                }
            }
            this.onProjectChanged = () => {
                this.item.subjectOfClaim.property = null;
            }

            this.addClient = (name, email, phone) => {
                let normalizedPhone = PhoneNumberFormatter.normalizeForCompare(phone) || phone
                return ClientFinderService.edit({fullName: name, contacts: buildClientContacts(email, normalizedPhone)}).then((client) => this.onClientSelected(client));
            }

            this.hasPhoneMismatch = (sourcePhone, clientPhone) => {
                let normalizedSourcePhone = PhoneNumberFormatter.normalizeForCompare(sourcePhone)
                let normalizedClientPhone = PhoneNumberFormatter.normalizeForCompare(clientPhone)
                return !!normalizedSourcePhone && !!normalizedClientPhone && normalizedSourcePhone !== normalizedClientPhone
            }

            function buildClientContacts(email, phone) {
                const contacts = []
                if (phone) {
                    contacts.push({type: 'PHONE', value: phone, name: 'Telefon', active: true, defaults: true})
                }
                if (email) {
                    contacts.push({type: 'EMAIL', value: email, name: 'Email', active: true, defaults: contacts.length === 0})
                }
                return contacts
            }
        })
        .controller('ServiceRequestPassController', function ($rootScope, $uibModalInstance, data, ServiceRequest, ServiceRequestConst) {
            this.$onInit = () => {
                this.item = data
                this.form = {
                    id: this.item.id
                }
            }

            this.cancel = () => $uibModalInstance.dismiss('Canceled')
            this.save = () => {
                return ServiceRequest.pass(this.form).$promise
                    .then(() => {
                        $uibModalInstance.close()
                        $rootScope.$broadcast("document.comments.reload", this.item.id)
                        $rootScope.$broadcast(ServiceRequestConst.eventUpdate)
                    })
            }
        })
        .controller('ServiceRequestPassOptOutController', function ($rootScope, $uibModalInstance, data, ServiceRequest, ServiceRequestConst) {
            this.$onInit = () => {
                this.item = data
                this.form = {
                    id: this.item.id
                }
            }

            this.cancel = () => $uibModalInstance.dismiss('Canceled')
            this.save = () => {
                return ServiceRequest.passOptOut(this.form).$promise
                    .then(() => {
                        $uibModalInstance.close()
                        $rootScope.$broadcast("document.comments.reload", this.item.id)
                        $rootScope.$broadcast(ServiceRequestConst.eventUpdate)
                    })
            }
        })
        .component('serviceRequestList', {
            bindings: {
                statistics: '<',
                filters: '<',
                page: '<'
            },
            templateUrl: 'app/service-request/list.html',
            controller: function ($scope, $state, $stateParams, ServiceRequest, ServiceRequestService, $interval, ServiceRequestIntegration, ServiceRequestConst) {
                this.ServiceRequestService = ServiceRequestService;
                this.reset = () => this.filters = {};

                this.integrationStatistics = [];
                this.integrationStatisticsPromise = null;

                this.$onInit = () => this.initAutoRefresh()
                this.initAutoRefresh = () => {
                    $interval.cancel(this.integrationStatisticsPromise)
                    ServiceRequestIntegration.statistics().$promise.then(result => {
                        this.integrationStatistics = result
                        if (result.find(integration => integration.count === null)) {
                            this.unprocessedCount = null;
                        } else {
                            this.unprocessedCount = result.reduce((sum, integration) => sum + integration.count, 0)
                        }
                    })
                    this.integrationStatisticsPromise = $interval(this.initAutoRefresh, 60000)
                }
                this.$onDestroy = () => $interval.cancel(this.integrationStatisticsPromise);
                this.findIntegrationStatistics = name => this.integrationStatistics.find(integration => integration.name === name);

                $scope.$on('client.updated', () => $state.reload());
                $scope.$on(ServiceRequestConst.eventUpdate, () => $state.reload());
            }
        })
        .component('serviceRequestShow', {
            bindings: {
                item: '<'
            },
            templateUrl: 'app/service-request/show.html',
            controller: function ($scope, $state, $window, ServiceRequestService, ServiceRequestConst, Principal) {
                this.ServiceRequestService = ServiceRequestService;
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);
                this.close = () => $window.history.back();

                $scope.$on('client.updated', () => $state.reload());
                $scope.$on(ServiceRequestConst.eventUpdate, () => $state.reload());
            }
        })
        .component('serviceRequestBtnOptions', {
            bindings: {
                item: '<',
                largeButton: '<'
            },
            templateUrl: 'app/service-request/_btn-options.html',
            controller: function (ServiceRequestService, FilesLibrary, FilesSimpleUploadService) {
                this.ServiceRequestService = ServiceRequestService;
                this.attachLibraryFile = entityId => FilesLibrary.openAndBind({type: 'service-request', id: entityId});
                this.attachFile = entityId => FilesSimpleUploadService.open({type: 'service-request', id: entityId});

                this.$onInit = () => {
                    this.isOpen = ServiceRequestService.isOpen(this.item);
                }
            }
        })
        .run(function (NavbarLeftMenu, Principal, $http, $interval, $rootScope, ServiceRequestConst) {
            const menuPath = '/service-request'

            function loadCounter() {
                Principal.identity().then(account => {
                    let auth = Principal.hasAnyAuthority(['ROLE_SERVICE_REQUEST'])
                    if (!auth) {
                        NavbarLeftMenu.updateCount(menuPath, 0)
                        return;
                    }

                    $http.get("/crm/api/service-request/table?status=FILLED&status=INVESTIGATION&status=IMPLEMENTATION").then(response => {
                        let statistics = response.data
                        NavbarLeftMenu.updateCount(menuPath, statistics.fullListSize)
                    }).catch(() => {
                        NavbarLeftMenu.updateCount(menuPath, 0)
                    })
                })
            }

            NavbarLeftMenu.add({
                authorities: "ROLE_SERVICE_REQUEST",
                path: "/service-request",
                ico: "fa fa-fw fa-wrench",
                name: 'service-request.menu',
                order: 92
            });

            $rootScope.$on(ServiceRequestConst.eventUpdate, () => loadCounter())
            $rootScope.$on("authenticationChanged", () => loadCounter())

            let intPromise = null;

            function initAutoRefresh() {
                $interval.cancel(intPromise)
                loadCounter()
                intPromise = $interval(initAutoRefresh, 60000)
            }

            this.$onDestroy = () => $interval.cancel(intPromise);

            initAutoRefresh()
        })
        .config(function ($stateProvider) {
            $stateProvider.state('serviceRequestList', {
                parent: 'app',
                url: '/service-request?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{category:int}&status&project&settlement&employee&employeeFilter',
                data: {
                    authorities: ['ROLE_SERVICE_REQUEST']
                },
                views: {
                    'content@': 'serviceRequestList'
                },
                params: {
                    status: { array: true, value: ['FILLED', 'INVESTIGATION', 'IMPLEMENTATION'], squash: false },
                },
                resolve: {
                    statistics: (ServiceRequest, $stateParams) => ServiceRequest.tableStatistics(angular.copy($stateParams)).$promise,
                    filters: $stateParams => angular.copy($stateParams),
                    page: (ServiceRequest, $stateParams) => ServiceRequest.table(angular.copy($stateParams)).$promise
                }
            });
            $stateProvider.state('serviceRequestShow', {
                parent: 'app',
                url: '/service-request/{id}',
                data: {
                    authorities: ['ROLE_SERVICE_REQUEST']
                },
                views: {
                    'content@': 'serviceRequestShow'
                },
                resolve: {
                    item: (ServiceRequest, $stateParams) => ServiceRequest.get({id: $stateParams.id}).$promise
                }
            });
        })
